import React, { createContext, useContext, useState, useEffect } from 'react';
import { mockStore } from '../mock/mock';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => mockStore.getCart());

  useEffect(() => {
    mockStore.saveCart(items);
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.productId === product.id);
      if (existing) {
        return prev.map((i) => i.productId === product.id ? { ...i, qty: i.qty + qty } : i);
      }
      return [...prev, { productId: product.id, name: product.name, price: product.price, image: product.image, slug: product.slug, qty }];
    });
  };

  const updateQty = (productId, qty) => {
    if (qty <= 0) return removeItem(productId);
    setItems((prev) => prev.map((i) => i.productId === productId ? { ...i, qty } : i));
  };

  const removeItem = (productId) => setItems((prev) => prev.filter((i) => i.productId !== productId));
  const clearCart = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
